var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Laag_1",
  "data-name": "Laag 1",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 219 60"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M59.88,54.72h-8V25.29L38.12,54.72H30.59L16,24.68v30h-8v-48h8.14L34.29,44,51.74,6.75h8.14Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M159.89,6.82v47.9h-8v-20H132v20h-8V6.82h8V26.66h19.91V6.82Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M183.48,49.18l-2,5.54h-8.62L191.9,5.45l19.16,49.27h-8.62l-2.12-5.54-2.6-6.92L191.9,25.64l-5.82,16.62Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M83.16,49l-2,5.54H72.48L91.58,5.28l19.16,49.27h-8.63L100,49l-2.6-6.91L91.58,25.47,85.76,42.1Z"
}))));
export { SvgLogo as ReactComponent };